/*
每屏视觉差指令

事件列表
  on_parallax_pined_top,
  on_parallax_un_pin_top,
  on_parallax_un_pin
注意, 该事件无需监听, 只需要在你要监听的组件内定义该方法即可
如, 有个组件叫做 VPaintViewer, 想要在该组件中获取事件, 只需按下方写法即可
当事件触发时候, 会自动调用该组件 methods 中定义的方法名
....
methods:{
  on_parallax_pined_top(payload){}
  on_parallax_un_pin_top(payload){}
  on_parallax_un_pin(payload){}
}
....

payload 参数包含以下值
{
  index: 当前组件所属的父级组件v-page所在的v-page列表中的序号,
         比如, 该组件是在第二个 v-page 调用的该组件, 那么 index 就是1(序号)
         如果是在第三个 v-page 调用的该组件, 那么 index 就是2(序号), 以此类推
  parentsVNode: v-parallax 指令中对应的 vNode 数据, 你可以通过vNode数据进行一些列更为复杂的判断
}
 */
import Parallax from "@/directives/parallax/parallax";

export default {
  install(Vue, options = {}) {
    Vue.directive("parallax", {
      inserted: (el, data, vNode) => {
        if (!vNode.context.$P.isIE11) {
          el.__parallax = new Parallax(el, vNode);
        }
      },
      unbind(el) {
        el.__parallax.destroy();
      },
    });
  },
};
